import { axiosInstance, axiosRequestWithAuth } from './../constants/server.constant';
import { getFullRegionDetail } from '../utility/utility';
export const VolumeService = {
    getAll,
    getByRegionId,
    createVolume,
    deleteVolumeById,
    updateVolumeById,
    doVolumeActionById,
    attachInstanceById,
    detachInstanceById,
    getBackupList,
    createBackupById,
    deleteBackupById,
    updateBackupById,
    restoreBackupById,
    getBackupById,
    getVolumeById
};

function getUserId() {
    return localStorage.getItem('userId');
}

async function getAll() {
    return await axiosInstance.get('/volumes/' + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            let items = resp.data;
            let volumes = [];
            let fullRegionList = JSON.parse(localStorage.getItem('fullRegionList'));
            for(var item of Object.keys(items)) {
                let volumeList = items[item];
                if(volumeList === null) {
                    continue;
                }
                volumeList.forEach(volume => {
                    let elem = volume;
                    let name = volume.name;
                    if(name.includes('backup-vol-')) {
                        let nameArr = name.split('backup-vol-');
                        let id = nameArr[1];
                        if(id !== null && id !== undefined) {
                            let ob = volumeList.find(itm => itm.id === id);
                            if(ob !== undefined) {
                                return;
                            }
                        }
                    }
                    elem.region = item;
                    if(!elem.created_at.includes('Z')) {
                        elem.created_at = elem.created_at + 'Z';
                    }
                    elem.fullRegion = getFullRegionDetail(fullRegionList, item);
                    volumes.push(elem);
                });
            }
            return volumes;
        }).catch(function (error) {
            return error;
        });
}

async function getByRegionId(regionId) {
    return await axiosInstance.get('/volumes/' + getUserId() + '/region?region=' + regionId, axiosRequestWithAuth)
        .then(resp => {
            let data = resp.data;
            let volumes = [];
            if(data.volumes && data.volumes.length > 0) {
                volumes = data.volumes;
            }
            return volumes;
        }).catch(function (error) {
            return error;
        });
}

async function createVolume(requestBody, regionUrl, isYearly) {
    requestBody = JSON.stringify(requestBody);
    return await axiosInstance.post('/volumes/' + getUserId() + '?region=' + regionUrl + "&isYearly=" + isYearly, requestBody, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return error;
        });
}

async function deleteVolumeById(volumeId, requestBody, regionUrl, regionName) {
    requestBody = JSON.stringify(requestBody);
    var reqHeaders = axiosRequestWithAuth;
    reqHeaders.data = requestBody;
    return await axiosInstance.delete('/volumes/' + getUserId() + '/' + volumeId + '?region=' + regionUrl + '&regionName=' + regionName, reqHeaders)
        .then(resp => {
            reqHeaders.data = undefined;
            return resp.data;
        }).catch(function (error) {
            reqHeaders.data = undefined;
            return false;
        });
}

async function updateVolumeById(volumeId, requestBody, regionUrl, regionName) {
    requestBody = JSON.stringify(requestBody);
    return await axiosInstance.put('/volumes/' + getUserId() + '/' + volumeId + '?region=' + regionUrl + '&regionName=' + regionName, requestBody, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function doVolumeActionById(volumeId, requestBody, regionUrl, regionName, param) {
    requestBody = JSON.stringify(requestBody);
    return await axiosInstance.put('/volumes/' + getUserId() + '/' + volumeId + '/default?region=' + regionUrl + '&regionName=' + regionName + '&isConfirm=' + param, requestBody, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}
async function attachInstanceById(instancesId, volumeId, regionUrl, regionName) {
    return await axiosInstance.post('/volumes/' + getUserId() + '/' + instancesId + '/' + volumeId + '/attach?region=' + regionUrl + '&regionName=' + regionName, {}, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}
async function detachInstanceById(instancesId, volumeId, regionUrl, regionName) {
    return await axiosInstance.delete('/volumes/' + getUserId() + '/' + instancesId + '/' + volumeId + '/detach?region=' + regionUrl + '&regionName=' + regionName, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function getBackupList() {
    return await axiosInstance.get('/volumes/' + getUserId() + '/backups', axiosRequestWithAuth)
        .then(resp => {
            let items = resp.data;
            let backups = [];
            let fullRegionList = JSON.parse(localStorage.getItem('fullRegionList'));
            for(var item of Object.keys(items)) {
                let backupList = items[item];
                if(backupList === null) {
                    continue;
                }
                backupList.forEach(volume => {
                    let elem = volume;
                    elem.region = item;
                    if(!elem.created_at.includes('Z')) {
                        elem.created_at = elem.created_at + 'Z';
                    }
                    elem.fullRegion = getFullRegionDetail(fullRegionList, item);
                    backups.push(elem);
                });
            }
            return backups;
        }).catch(function (error) {
            return [];
        });
}

async function createBackupById(requestBody, region) {
    requestBody = JSON.stringify(requestBody);
    return await axiosInstance.post('/volumes/' + getUserId() + '/backups?region=' + region, requestBody, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function deleteBackupById(backupId, region) {
    return await axiosInstance.delete('/volumes/' + backupId + '/backups/' + getUserId() + '?region=' + region, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function updateBackupById(backupId, requestBody, region) {
    requestBody = JSON.stringify(requestBody);
    return await axiosInstance.put('/volumes/' + backupId + '/backups/' + getUserId() + '?region=' + region, requestBody, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function restoreBackupById(backupId, requestBody, region, isYearly) {
    return await axiosInstance.post('/volumes/' + backupId + '/backups/restore/' + getUserId() + '?region=' + region + '&isYearly=' + isYearly, requestBody, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function getBackupById(backupId, region) {
    return await axiosInstance.get('/volumes/' + backupId + '/backups/' + getUserId() + '?region=' + region, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;;
        }).catch(function (error) {
            return [];
        });
}

async function getVolumeById(volumeId, region) {
    return await axiosInstance.get('/volumes/' + getUserId() + '/' + volumeId + '?region=' + region, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;;
        }).catch(function (error) {
            return [];
        });
}
export default VolumeService;